jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.gallery-slider').length ) {
        let $ = jQuery;

        $(".gallery-slider .gallery").each(function() {
            $(this).slick({
                slidesToShow: 1,
                rows: 0,
                dots: true,
                arrows: true,
                fade: true,
                autoplay: true,
                autoplaySpeed: 7000,
                scrollable: true
            });
            $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
                var $slides = slick.$slides;
                var id = $slides.eq(currentSlide).get(0).id;
                $url = $("#" + id).data('url');
                $(this).css("background-image", 'url(' + $url + ')');
            });
        });

    }
});